const mockapi = 'https://62a6e5a797b6156bff81e2bc.mockapi.io';

export default mockapi;
